import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Spinner,
} from "reactstrap";
import swal from "sweetalert2";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import Line from "../../../AllCharts/echart/linechart";
import Pie from "../../../AllCharts/echart/piechart";
import showNotification from "../../../../helpers/show_notification";
import { formatUnitsForReport } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";

const ItemOrderReport = (props) => {
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [selectedBranch, setSelectedBranch] = useState("All");
  const [allBranches, setAllBranches] = useState([]);
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);
  const pieRequestId = useRef(0);
  const lineRequestId = useRef(0);

  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    setDateFrom(formatDate(firstDay));
    setDateTo(formatDate(currentDay));
    loadAllBranches();
  }, []);

  // useEffect(() => {
  //   if (dateFrom && dateTo) {
  //     loadOrders();
  //     loadOrdersPieChartData();
  //     loadOrdersLineChartData();
  //   }
  // }, [dateFrom, dateTo, selectedBranch]);
  const [selectedRow, setSelectedRow] = useState([]);
  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const branches = response.data.filter(
        (store) =>
          store.type === "Branch" || store.type === "CENTRAL KITCHEN STORE",
      );
      setAllBranches(branches);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [editModal, setEditModal] = useState();

  const [allOrders, setAllOrders] = useState([]);

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      const daysDiff = moment(dateTo).diff(dateFrom, "days");
      if (daysDiff > 31) {
        setAllOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (daysDiff < 0) {
        setAllOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      setIsLoadingOrders(true);
      setAllOrders([]);
      const url = process.env.REACT_APP_BASEURL + "itemorders/get_datewise";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch,
        date_from: dateFrom ? dateFrom : moment().format("YYYY-MM-DD"),
        date_to: dateTo ? dateTo : moment().format("YYYY-MM-DD"),
      });
      if (requestId !== ordersRequestId.current) return;

      if (response && response.status === 1) {
        const result = response.data || [];
        if (result.length <= 0) {
          setAllOrders([]);
          showNotification("No Orders data found", "error");
        } else {
          setAllOrders(result);
          setTablePage(1);
        }
      } else {
        setAllOrders([]);
        showNotification((response && response.message) || "Error", "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return;
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };
  const [orderStatus, setOrderStatus] = useState("All");
  const [filteredOrders, setFilteredOrders] = useState([]);
  useEffect(() => {
    if (orderStatus === "All") {
      setFilteredOrders([...allOrders]);
    } else {
      let arr = allOrders.filter((order) => order.status === orderStatus);
      setFilteredOrders(arr);
    }
  }, [allOrders, orderStatus]);

  const [ordersPieChartData, setOrdersPieChartData] = useState();
  const loadOrdersPieChartData = async () => {
    const requestId = ++pieRequestId.current;
    let url = process.env.REACT_APP_BASEURL + "itemorders/report_daterange_pie";
    const response = await postSubmitForm(url, {
      branch_id: selectedBranch,
      date_from: dateFrom,
      date_to: dateTo,
    });
    if (requestId !== pieRequestId.current) return;
    if (response && response.status === 1) {
      setOrdersPieChartData(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [ordersLineChartStatus, setOrdersLineChartStatus] = useState("Closed");
  const [ordersLineChartData, setOrdersLineChartData] = useState();
  useEffect(() => {
    if (dateFrom && dateTo && ordersLineChartStatus) {
      loadOrdersLineChartData();
    }
  }, [ordersLineChartStatus]);
  const loadOrdersLineChartData = async () => {
    const requestId = ++lineRequestId.current;
    let url =
      process.env.REACT_APP_BASEURL + "itemorders/report_daterange_line";
    const response = await postSubmitForm(url, {
      branch_id: selectedBranch,
      date_from: dateFrom,
      date_to: dateTo,
      status: ordersLineChartStatus,
    });
    if (requestId !== lineRequestId.current) return;
    if (response && response.status === 1) {
      setOrdersLineChartData(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  function detailsFormatter(cell, row) {
    return (
      <>
        <span className="text-info" style={{ marginLeft: "5px" }}>
          <i
            className="bx bx-news font-size-15"
            title="View"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedRow(row);

              //getPatientDetails(row.patient_details.patient_id);
              setEditModal(!editModal);
              //console.log(row);
              //setSelectedPackage(row._id);
              //setPackagesForPatient(selectedPackage)
            }}
          ></i>
        </span>
      </>
    );
  }

  const columns_external = [
    {
      dataField: "row_number",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => {
        return (tablePage - 1) * pageSize + rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Order Date"),
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
      sort: true,
      dataField: "createdAt",
      formatter: (cell, row, rowIndex) => {
        return moment(row.createdAt).format("YYYY-MM-DD HH:mm");
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "order_id",
      text: props.t("Order ID"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "branch_details.name",
      text: props.t("Branch Name"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },

      style: { cursor: "pointer" },
    },

    {
      dataField: "status",
      text: props.t("Status"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },

      style: { cursor: "pointer" },
    },
    {
      text: props.t("Action"),
      formatter: detailsFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
  ];

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Completed") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Booked") {
      style.backgroundColor = "#9ec3ff";
    } else if (row.status === "In Process") {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Cancelled") {
      style.backgroundColor = "#ff9e9e";
    }

    return style;
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "items_Order_report";
    const exportType = "xls";

    let data_to_export = filteredOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Order_Date: v.createdAt,
          Order_Id: v.order_id,
          Branch_Name: v.branch_details.name,
          Status: v.status,
          Remarks: v.remarks,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Item Order Report")}
            title={props.t("Reports")}
            breadcrumbItem1={props.t("Orders")}
            breadcrumbItem2={props.t("Item Order Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="branch"
                          label={props.t("Branch")}
                          type="select"
                          value={selectedBranch}
                          onChange={(e) => {
                            setSelectedBranch(e.target.value);
                          }}
                        >
                          <option value="All">{props.t("All")}</option>
                          {allBranches &&
                            allBranches.map((branch) => {
                              return (
                                <option key={branch._id} value={branch._id}>
                                  {branch.name}
                                </option>
                              );
                            })}
                        </AvField>
                      </Col>
                      <Col lg={3}>
                        {" "}
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                              loadOrdersPieChartData();
                              loadOrdersLineChartData();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={6}>
                      <CardTitle>
                        {ordersLineChartStatus &&
                          props.t(ordersLineChartStatus + "Orders Chart")}
                      </CardTitle>
                    </Col>
                    <Col lg={6}>
                      <AvForm>
                        <AvField
                          name="orderStatusLineChart"
                          label={""}
                          type="select"
                          value={ordersLineChartStatus}
                          onChange={(e, v) => {
                            setOrdersLineChartStatus(e.target.value);
                          }}
                        >
                          <option value="Placed">{props.t("Placed")}</option>
                          <option value="Approved">
                            {props.t("Approved")}
                          </option>

                          <option value="Dispatched">
                            {props.t("Dispatched")}
                          </option>
                          <option value="Partially Dispatched">
                            {props.t("Partially Dispatched")}
                          </option>
                          <option value="Closed">{props.t("Closed")}</option>
                        </AvField>
                      </AvForm>
                    </Col>
                  </Row>

                  <div id="line-chart" className="e-chart">
                    <Line
                      line_data={ordersLineChartData && ordersLineChartData}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg="6">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Orders Pie")}</CardTitle>
                  <div id="pie-chart" className="e-chart">
                    <Pie
                      orders_pie_data={ordersPieChartData && ordersPieChartData}
                      name={props.t("Orders Pie")}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("All Orders")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all orders here")}
                  </CardSubtitle>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <ToolkitProvider
                    keyField="_id"
                    data={filteredOrders && filteredOrders}
                    columns={columns_external}
                    bootstrap4
                    search
                  >
                    {(toolkitProps) => (
                      <div>
                        <Row>
                          <Col lg={4}>
                            <SearchBar
                              {...toolkitProps.searchProps}
                              style={{ width: "300px" }}
                            />
                          </Col>
                          <Col lg={4}></Col>
                          <Col lg={4} className="text-right">
                            <select
                              name="status"
                              className="form-control"
                              value={orderStatus}
                              onChange={(e) => {
                                setOrderStatus(e.target.value);
                              }}
                            >
                              <option value="All">All</option>
                              <option value="Placed">Placed</option>
                              <option value="Approved">Approved</option>
                              <option value="Dispatched">Dispatched</option>
                              <option value="Partially Dispatched">
                                Partially Dispatched
                              </option>
                              <option value="Closed">Closed</option>
                            </select>
                          </Col>
                        </Row>
                        <BootstrapTable
                          striped
                          hover
                          condensed
                          rowStyle={rowStyle}
                          pagination={paginationFactory(pagination_options)}
                          noDataIndication={
                            isLoadingOrders ? (
                              <Spinner size="md" />
                            ) : (
                              props.t("No data to display.")
                            )
                          }
                          {...toolkitProps.baseProps}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            size="lg"
            isOpen={editModal}
            toggle={() => setEditModal(!editModal)}
          >
            <ModalHeader toggle={() => setEditModal(!editModal)}>
              {"    "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv1");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiv1">
                <Col lg={12}>
                  <CardTitle className="text-center">
                    {props.t("Item order details")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          {/* <h5> Branch: {selectedRow.name}</h5> */}
                          <BootstrapTable
                            keyField="_id"
                            data={
                              selectedRow.item_details &&
                              selectedRow.item_details
                            }
                            columns={columns}
                            striped
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ItemOrderReport)),
);
